import { createAction } from "@ngrx/store";

export const toggleDarkMode = createAction("Toggle Dark Mode");